import { PaywallElement } from '@/paywallElement';
import { PostAdvertisementOpportunityLogo } from './nodes/advertisementOpportunityLogo';
import { PostAudio } from './nodes/audio';
import { PostBackLink } from './nodes/backLink';
import { PostBlockquoteFigure } from './nodes/blockquoteFigure/BlockquoteFigure';
import { PostQuote } from './nodes/blockquoteFigure/Quote';
import { PostQuoteCaption } from './nodes/blockquoteFigure/QuoteCaption';
import { PostBoost } from './nodes/boost';
import { PostBulletList } from './nodes/bulletList';
import { PostButton } from './nodes/button';
import { PostCashTag } from './nodes/cashtag';
import { PostCodeBlock } from './nodes/codeBlock';
import { PostColumn, PostColumns } from './nodes/columns/Columns';
import { Document } from './nodes/document';
import { Emoji } from './nodes/emoji';
import { FigCaption } from './nodes/figCaption';
import { PostFileAttachment } from './nodes/fileAttachment';
import { PostFootnoteItem } from './nodes/footnoteItem';
import { PostFootnotesMarker } from './nodes/footnotesMarker';
import { PostFootnotesNode } from './nodes/footnotesNode';
import {
  PostGenericEmbed,
  PostGenericEmbedDescription,
  PostGenericEmbedHost,
  PostGenericEmbedTitle,
} from './nodes/genericEmbed';
import { PostHeading } from './nodes/heading';
import { HorizontalRule } from './nodes/horizontalRule/HorizontalRule';
import { PostHTMLSnippet } from './nodes/htmlSnippet/HTMLSnippet';
import { ImageBlock } from './nodes/imageBlock';
import { PostListItem } from './nodes/listItem';
import { PostNumberedList } from './nodes/numberedList';
import { Paragraph } from './nodes/paragraph/Paragraph';
import { PostPoll } from './nodes/poll';
import { PostRecommendation } from './nodes/recommendation';
import { PostRss } from './nodes/rss';
import { PostSection } from './nodes/section';
import { ServiceEmbed } from './nodes/serviceEmbed';
import { PostSubscriberBreak } from './nodes/subscriberBreak';
import { PostTable, PostTableCell, PostTableHeader, PostTableRow } from './nodes/table';
import { PostTableOfContents } from './nodes/tableOfContents/TableOfContents';
import { SerializeTextLeaf } from './nodes/textLeaf/Text';

export const componentMap: Record<string, React.ComponentType<any>> = {
  doc: Document,
  paragraph: Paragraph,
  imageBlock: ImageBlock,
  figcaption: FigCaption,
  listItem: PostListItem,
  bulletList: PostBulletList,
  orderedList: PostNumberedList,
  heading: PostHeading,
  blockquoteFigure: PostBlockquoteFigure,
  quote: PostQuote,
  quoteCaption: PostQuoteCaption,
  columns: PostColumns,
  column: PostColumn,
  section: PostSection,
  table: PostTable,
  tableCell: PostTableCell,
  tableHeader: PostTableHeader,
  tableRow: PostTableRow,
  button: PostButton,
  genericEmbed: PostGenericEmbed,
  genericEmbedTitle: PostGenericEmbedTitle,
  genericEmbedHost: PostGenericEmbedHost,
  genericEmbedDescription: PostGenericEmbedDescription,
  tableOfContents: PostTableOfContents,
  codeBlock: PostCodeBlock,
  horizontalRule: HorizontalRule,
  audio: PostAudio,
  poll: PostPoll,
  fileAttachment: PostFileAttachment,
  paywallBreak: PaywallElement,
  recommendation: PostRecommendation,
  boost: PostBoost,
  rss: PostRss,
  htmlSnippet: PostHTMLSnippet,
  subscriberBreak: PostSubscriberBreak,
  advertisementOpportunityLogo: PostAdvertisementOpportunityLogo,
  serviceEmbed: ServiceEmbed,
  text: SerializeTextLeaf,
  emoji: Emoji,
  footnotesNode: PostFootnotesNode,
  footnoteMarker: PostFootnotesMarker,
  footnoteItem: PostFootnoteItem,
  cashtag: PostCashTag,
  backlink: PostBackLink,
};
